/* eslint-disable react/no-danger, jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import PropTypes from 'prop-types';
import MediaGalleryListItem from './MediaGalleryListItem';

const MediaGalleryList = props => (
  <div>
    {props.items.length === 0
      && (
        <div className="message warning-message">
          <p className="body-sm" dangerouslySetInnerHTML={{ __html: window.noMatchesErrorMessage }} />
        </div>
      )
    }
    <div className="media-gallery-list" id="media-gallery-list" tabIndex="0">
      {props.items.map(item => <MediaGalleryListItem key={item} item={item} handleMediaClick={props.handleMediaClick} />)}
    </div>
  </div>
);

MediaGalleryList.propTypes = {
  handleMediaClick: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

export default MediaGalleryList;
/* eslint-enable react/no-danger, jsx-a11y/no-noninteractive-tabindex */
